import cn from 'classnames';
import React from 'react';
import ReactModal from 'react-modal';

import * as localizationKeys from '../../consts/localization/localizationKeys';
import domService from '../../services/domService';
import {getLocalizedStrings} from '../../services/localization/localizationService';
import helpers from '../../utils/helpers';
import {CancelIcon} from '../Icons';
import styles from './Popup.module.scss';

const AppPopup = (props) => {
    //IA: closeTimeoutMS = 1 is needed to run popup 'close' function
    //    if Popup component is removed from DOM NOT by isOpen property
    const {
        contentLabel,
        children,
        className,
        closeTimeoutMS = 1,
        shouldReturnFocusAfterClose,
        isCloseVisible,
        onClose,
        closeButtonAriaLabel,
        closeButtonTestId = '',
        ...restProps
    } = props;
    const isCloseFunction = typeof onClose === 'function';
    const onPopupClose = (action) => {
        if (isCloseFunction) {
            helpers.runFunction(onClose);

            if (action) {
                helpers.runFunction(action);
            }
        }
    };

    const localizedStrings = getLocalizedStrings();
    const defaultContentLabel = localizedStrings[localizationKeys.GLOBAL_POPUP_ARIA_LABEL];

    return (
        <ReactModal
            contentLabel={contentLabel || defaultContentLabel}
            parentSelector={domService.getComponentsWrapperElement}
            shouldReturnFocusAfterClose={shouldReturnFocusAfterClose}
            className={cn(styles.AppPopup, className)}
            closeTimeoutMS={closeTimeoutMS}
            ariaHideApp={false}
            shouldCloseOnOverlayClick
            shouldCloseOnEsc
            onRequestClose={onPopupClose}
            {...restProps}
        >
            {isCloseVisible && (
                <button
                    className='absolute right-3.5 top-3.5 cursor-pointer p-2.5 rtl:left-6 rtl:right-[unset] lg:right-6 lg:top-6 lg:px-1.5 lg:py-px'
                    onClick={() => onClose(false)}
                    aria-label={closeButtonAriaLabel}
                    data-testid={closeButtonTestId}
                >
                    <CancelIcon />
                </button>
            )}
            {children}
        </ReactModal>
    );
};

export default AppPopup;
